import React from 'react';
import CardProducto from '../Inicio/CardProducto';
import ReactPaginate from 'react-paginate';
import CardPServicio from './CardPServicio';

function ContenedorProductosServicios({
  itemsPS,
  onPageChange,
  pageCount,
  currentPage, // Recibe la página actual como prop
  type,
  isLoading, // Recibe el estado de carga
}) {
  return (
    <div className="w-full h-full flex flex-col">
      {/* Mensaje de carga */}
      {isLoading ? (
        <div className="w-full h-full flex justify-center items-center text-xl font-bold text-GrisOscuro">
          {type === 'servicios' && 'Cargando servicios...'}
          {type === 'productos' && 'Cargando productos...'}
        </div>
      ) : (
        // Verificar si hay productos/servicios disponibles
        <>
          <div className="w-full h-full flex flex-wrap justify-center p-5 overflow-auto">
            {itemsPS.length > 0 ? (
              type === 'servicios' ? (
                itemsPS.map((s, index) => (
                  <div key={index} className="flex justify-center mb-4">
                    <CardPServicio servicio={s} />
                  </div>
                ))
              ) : (
                itemsPS.map((p, index) => (
                  <div key={index} className="flex justify-center mb-4">
                    <CardProducto producto={p} />
                  </div>
                ))
              )
            ) : (
              <div className="text-xl font-bold text-Rojo mt-10">
                {type === 'servicios' && 'No hay servicios con esas características....'}
                {type === 'productos' && 'No hay productos con esas características....'}
              </div>
            )}
          </div>
  
          {/* Paginador */}
          {itemsPS.length > 0 && (
            <div className="flex w-full flex-row h-20 justify-center items-end">
              <ReactPaginate
                breakLabel="..."
                nextLabel=">"
                onPageChange={(event) => onPageChange(event)}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                previousLabel="<"
                renderOnZeroPageCount={null}
                forcePage={currentPage - 1} // Sincroniza el paginador con la página actual
                containerClassName="flex justify-center items-center"
                pageClassName="p-1 px-3 text-Blanco bg-GrisClaro"
                activeClassName="bg-GrisOscuro text-Negro"
                previousClassName="px-2 py-1 text-Rojo font-bold text-xl"
                nextClassName="px-2 py-1 text-Rojo font-bold text-xl"
                breakClassName="px-2 py-1 text-Rojo"
              />
            </div>
          )}
        </>
      )}
    </div>
  );
  
}

export default ContenedorProductosServicios;
